import { getRouteApi, useNavigate } from '@tanstack/react-router';
import { CertificateDetails } from '../components/certificate-details/certificate-details.js';
import { PortalShell } from '../components/portal-shell.js';

const route = getRouteApi('/_authenticated/certificates/$certificateId');

export function CertificateDetailsPage() {
  const { certificateId } = route.useParams();
  const navigate = useNavigate();

  return (
    <PortalShell activeId="certificates" pageTitle="Certificate details">
      <div className="mx-auto max-w-[1480px] px-8 pb-12 pt-8">
        <CertificateDetails
          certificateId={certificateId}
          onBack={() => void navigate({ to: '/certificates' })}
          onEdit={() =>
            void navigate({ to: '/certificates/$certificateId/edit', params: { certificateId } })
          }
        />
      </div>
    </PortalShell>
  );
}
